'use client';

import { useTranslations } from 'next-intl';
import React, { FC, memo } from 'react';

import { Avatar } from '@/.gql/graphql';
import { AvatarItem } from '@/src/components/AvatarItem';
import { AvatarYourPhoto } from '@/src/components/AvatarYourPhoto';
import { useStyleContext, TAiVideo } from '@/src/providers';

const styles = {
  chooseTitle: 'text-base font-bold mb-3',
  options: 'flex gap-y-2 gap-x-4 flex-wrap',
  noAvatar: 'font-medium text-label-secondary text-sm',
};

export interface TAvatarsProps {
  avatars: Avatar[];
}

export const VideoAvatarsComponent: FC<TAvatarsProps> = ({ avatars }) => {
  const t = useTranslations('imageModal');
  const { activeStyle } = useStyleContext();

  return (
    <div>
      <div className={styles.chooseTitle}>
        {avatars?.length ? t('chooseTitle') : t('noAvatarTitle')}
      </div>

      <div className={styles.options}>
        {(activeStyle as TAiVideo).videoStyleId && <AvatarYourPhoto />}
        {avatars?.length && (activeStyle as TAiVideo).videoLookId ? (
          avatars.map((avatar) => (
            <AvatarItem key={avatar.id} avatar={avatar} />
          ))
        ) : !avatars?.length && !(activeStyle as TAiVideo).videoStyleId ? (
          <div className={styles.noAvatar}>{t('noAvatarText')}</div>
        ) : null}
      </div>
    </div>
  );
};

export const VideoAvatars = memo(VideoAvatarsComponent);
